import { EmbeddedVideoSource } from "features/Library/EmbeddedVideos/types/models";
import * as Yup from "yup";
import { requiredTextFieldMinMax } from "./commonValidationSchemas";
import { labelValues, softwareApplicationValues } from "./tagsValidationSchema";

const titleLengths = {
  min: 3,
  max: 120,
};

const descriptionLengths = {
  min: 3,
  max: 256,
};

const videoUrlMaxLength = 256;

export const embeddedVideoConfiguration = Yup.object().shape({
  title: requiredTextFieldMinMax("Title", titleLengths.min, titleLengths.max),
  description: requiredTextFieldMinMax("Description", descriptionLengths.min, descriptionLengths.max),
  videoUrl: Yup.string()
    .url("Invalid URL")
    .trim()
    .required("Video URL is required")
    .max(videoUrlMaxLength, `Video URL cannot exceed ${videoUrlMaxLength} characters`),
  source: Yup.mixed<EmbeddedVideoSource>()
    .oneOf(
      [EmbeddedVideoSource.YouTube, EmbeddedVideoSource.Vimeo, EmbeddedVideoSource.Wistia, EmbeddedVideoSource.Vidyard],
      "Invalid video source",
    )
    .required("Video Source is required"),
  thumbnailUrl: Yup.string().trim().required("Thumbnail Image is required"),
});

export const embeddedVideoSettings = Yup.object().shape({
  labels: labelValues,
  softwareApplications: softwareApplicationValues,
});
